import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const ambulanceIcon = L.divIcon({
  className: "",
  html: `<div style="background:#0ea5e9;width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:3px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.3)">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 10H6"/><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>
  </div>`,
  iconSize: [34, 34],
  iconAnchor: [17, 17],
});

function Recenter({ lat, lon }) {
  const map = useMap();
  useEffect(() => {
    if (lat && lon) map.setView([lat, lon], map.getZoom() || 13, { animate: true });
  }, [lat, lon, map]);
  return null;
}

const MAP_STYLE = { height: 280, width: "100%" };

export function TrackingMap({ location }) {
  const center = location ? [location.lat, location.lon] : [47.322, 5.041];
  return (
    <div className="rounded-md overflow-hidden border border-border" data-testid="tracking-map">
      <MapContainer center={center} zoom={13} style={MAP_STYLE} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {location && <Marker position={[location.lat, location.lon]} icon={ambulanceIcon} />}
        {location && <Recenter lat={location.lat} lon={location.lon} />}
      </MapContainer>
    </div>
  );
}
